import React, { memo } from 'react';
import { Select } from 'antd';
import { shallowEqual, useSelector } from 'react-redux';
import { ReactComponent as LifecycleFilterIcon } from '../../../../../../resource/GeneralFilterIcon.svg';
import {
  hasFilterValue,
  selectLifecycleActiveCount,
} from '../../../model/activity';
import { useRequestFilterCommands } from '../../../model/commandsContext';
import { useFilterChange } from '../../../model/useFilterChange';
import FilterField from '../../primitives/FilterField';
import FilterSection from '../../primitives/FilterSection';
import { multiSelectTagProps } from '../../primitives/selectTagProps';
import styles from './LifecycleFilterSection.module.scss';

const { Option } = Select;

const selectLifecycleFilterState = (state) => {
  const filter = state.filterStore;

  return {
    valueCheckedStage: filter.valueCheckedStage,
    valueStageFlat: filter.valueStageFlat,
    valueStageCurrentFlat: filter.valueStageCurrentFlat,
    valueAcceptanceStatusesFlat: filter.valueAcceptanceStatusesFlat,
    filterStage: filter.filterStage,
    filterAcceptanceStatuses: filter.filterAcceptanceStatuses,
  };
};

const createLifecycleOptions = (items) => {
  if (!items?.length) return null;

  return items
    .map((item, index) => (
      <Option
        key={item.id || `lifecycle-${index}`}
        value={item.id}
        searchtext={item.name}
      >
        {item.name}
      </Option>
    ))
    .concat([
      <Option
        key={0}
        value={0}
        searchtext="Дополнительный"
      >
        Не указан
      </Option>,
    ]);
};

const LifecycleSelect = memo(({ placeholder, value, items, onChange }) => (
  <Select
    {...multiSelectTagProps}
    mode="multiple"
    placeholder={placeholder}
    notFoundContent="нет данных"
    defaultActiveFirstOption={false}
    allowClear={true}
    optionFilterProp="searchtext"
    value={value}
    onChange={onChange}
  >
    {createLifecycleOptions(items)}
  </Select>
));

const LifecycleFilterSection = () => {
  const filterCommands = useRequestFilterCommands();
  const filter = useSelector(selectLifecycleFilterState, shallowEqual);
  const activeCount = useSelector(selectLifecycleActiveCount);
  const { changeFilter } = useFilterChange();

  if (!filter.valueCheckedStage) return null;

  return (
    <FilterSection
      heading="Стадии жизненного цикла"
      description="Состояние помещения при создании и сейчас"
      icon={<LifecycleFilterIcon />}
      activeCount={activeCount}
      collapsible={false}
    >
      <div className={styles.grid}>
        <FilterField
          label="Жизненный цикл при создании заявки"
          active={hasFilterValue(filter.valueStageFlat)}
        >
          <LifecycleSelect
            placeholder="Выберите стадию"
            value={filter.valueStageFlat}
            items={filter.filterStage}
            onChange={(value) => {
              changeFilter(filterCommands.setStageFlatValue(value));
            }}
          />
        </FilterField>

        <FilterField
          label="Жизненный цикл текущий"
          active={hasFilterValue(filter.valueStageCurrentFlat)}
        >
          <LifecycleSelect
            placeholder="Выберите стадию"
            value={filter.valueStageCurrentFlat}
            items={filter.filterStage}
            onChange={(value) => {
              changeFilter(filterCommands.setStageCurrentFlatValue(value));
            }}
          />
        </FilterField>

        <FilterField
          label="Результат приёмки"
          active={hasFilterValue(filter.valueAcceptanceStatusesFlat)}
          className={styles.fullWidth}
        >
          <LifecycleSelect
            placeholder="Выберите результат"
            value={filter.valueAcceptanceStatusesFlat}
            items={filter.filterAcceptanceStatuses}
            onChange={(value) => {
              changeFilter(
                filterCommands.setAcceptanceStatusesFlatValue(value)
              );
            }}
          />
        </FilterField>
      </div>
    </FilterSection>
  );
};

export default memo(LifecycleFilterSection);
